import { G as t } from "./glightbox-13d8fc52.js";
import "./_commonjsHelpers-10dfc225.js";
const l = {
  props: {
    media: {
      type: Array,
      default: () => []
    },
    startAt: {
      type: Number,
      default: 0
    }
  },
  emits: ["close"],
  computed: {
    elements() {
      return this.media.map((e) => ({
        href: e.src,
        type: e.type || "image"
      }));
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.gallery = t({
        elements: this.elements,
        startAt: this.startAt,
        plyr: {
          config: {
            quality: { default: 1080 }
          }
        }
      }), this.gallery.on("close", this.close), this.gallery.open();
    });
  },
  beforeUnmount() {
    this.gallery.destroy();
  },
  methods: {
    close() {
      this.$emit("close");
    }
  },
  render() {
    return null;
  }
};
export {
  l as default
};
